/**
 * ClusterMarker
 */

import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fitBounds } from 'google-map-react/utils';
import * as actionCreators from '../../actions/actionCreators';

class ClusterMarker extends React.Component {
    constructor(props) {
        super(props);
    }

    pressFunction = event => {
        //on enter key
        if(event.keyCode === 13) {
            this.handleClick();
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.pressFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.pressFunction, false);
    }

    handleClick = () => {
        const lats = this.props.item.points.map(point => {
            return point.lat;
        });
        const lngs = this.props.item.points.map(point => {
            return point.lng;
        });
        const maxLat = Math.max.apply(Math, lats);
        const minLat = Math.min.apply(Math, lats);
        const maxLng = Math.max.apply(Math, lngs);
        const minLng = Math.min.apply(Math, lngs);
        const bounds = {
            ne: {
                lat: maxLat,
                lng: maxLng
            },
            sw: {
                lat: minLat,
                lng: minLng
            }
        };

        const { center, zoom } = fitBounds(bounds, this.props.mapContainerDimensions);

        this.props.setCenter(center);
        this.props.setZoom(zoom);
    };

    render() {
        const size = 42;
        const markerStyle = {
            position: 'absolute',
            width: size,
            height: size,
            left: -size / 2,
            top: -size / 2
        };

        const classesMarker = classNames('ClusterMarker', {
            [`ClusterMarker--Active`]: this.props.activeMarker
        });

        return (
            <div
                className={classesMarker}
                style={markerStyle}
                onClick={this.handleClick}
                tabIndex="0"
            >
                {this.props.item.numPoints}
            </div>
        );
    }
}

ClusterMarker.defaultProps = {
    item: {}
};

function mapStateToProps(state) {
    return {
        mapContainerDimensions: state.map.mapContainerDimensions
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ClusterMarker);
